import { useState } from "react";
import classNames from "classnames";

import useReorderAnimation from "/hooks/use-reorder-animation";

import Button from "/components/Button";
import TextField from "/components/TextField";

import longArrowUpIcon from "/assets/long-arrow-up.svg";
import longArrowDownIcon from "/assets/long-arrow-down.svg";

export default function TeamForm({
  useStore,
  onRemove,
  onOrderUp,
  onOrderDown,
}) {
  const store = useStore();
  // Member rows are short enough to stay on screen on their own, so they just
  // swap places — no scroll compensation.
  const reorderMember = useReorderAnimation(".team-form__member", { compensateScroll: false });

  return (
    <div className={classNames("team-form flex-col gap-10", { "team-form--hidden": store.hidden })}>
      <div className="actions-bar actions-bar--nested">
        <div></div>
        <div>
          <div className="actions-bar__order-buttons">
            <Button onClick={onOrderUp} className="btn--icon"><img src={longArrowUpIcon} alt="Переместить вверх" /></Button>
            <Button onClick={onOrderDown} className="btn--icon"><img src={longArrowDownIcon} alt="Переместить вниз" /></Button>
          </div>

          <Button
            className="lnk lnk--blue"
            onClick={() => store.setHidden(!store.hidden)}
          >
            {store.hidden ? "Отобразить" : "Скрыть"}
          </Button>
          <Button onClick={onRemove} className="lnk lnk--red">Удалить</Button>
        </div>
      </div>

      <div className="inpt-line">
        <TextField
          placeholder="название команды"
          value={store.name_ru}
          onChange={store.setNameRu}
        />

        <TextField
          placeholder="team name"
          value={store.name_en}
          onChange={store.setNameEn}
        />
      </div>

      {store.members.map((member, index) => (
        <div key={member.key} className="team-form__member flex-col gap-3">
          <div className="inpt-line">
            <TextField
              placeholder="фамилия имя"
              value={member.name_ru}
              onChange={(value) => store.setMemberNameRu(index, value)}
            />

            <TextField
              placeholder="full name"
              value={member.name_en}
              onChange={(value) => store.setMemberNameEn(index, value)}
            />
            {(store.members.length > 1) && (
              <div className="inpt-line__actions">
                <div className="inpt-line__order-buttons">
                  <Button
                    onClick={(event) => reorderMember(event, () => store.orderUpMember(index))}
                    className="btn--icon"
                  >
                    <img src={longArrowUpIcon} alt="Переместить вверх" />
                  </Button>
                  <Button
                    onClick={(event) => reorderMember(event, () => store.orderDownMember(index))}
                    className="btn--icon"
                  >
                    <img src={longArrowDownIcon} alt="Переместить вниз" />
                  </Button>
                </div>

                <Button
                  onClick={() => store.removeMember(index)}
                  className="lnk lnk--red"
                >
                  Удалить
                </Button>
              </div>
            )}
          </div>
          <div className="inpt-line">
            <TextField
              value={member.position_ru}
              onChange={(value) => store.setMemberPositionRu(index, value)}
              placeholder="должность"
            />

            <TextField
              value={member.position_en}
              onChange={(value) => store.setMemberPositionEn(index, value)}
              placeholder="position"
            />
          </div>
        </div>
      ))}

      <div>
        <Button onClick={store.addMember}>+ сотрудник</Button>
      </div>
    </div>
  );
}
